module.exports = __webpack_public_path__ + "media/images/img_point2-e3a7c76b914873c28a22083d9c8e317a.jpg";